import { ICartEntry, MinimalCartEntryType } from 'features/cart/types';
import { StyleSheet, View } from 'react-native';

import { primitive } from 'styles/constants';

import { useCartContext } from '../../hooks/use-cart-context';

import { CartEntryBody } from './cart-entry-body';
import { CartEntryFooter } from './cart-entry-footer';
import { CartEntryHeader } from './cart-entry-header';

export const CartEntry = ({
  cartEntry,
  readOnly = false,
  quantityOnCart,
}: {
  cartEntry: ICartEntry;
  readOnly?: boolean;
  quantityOnCart?: number;
}) => {
  const { isContinueLoading } = useCartContext();
  const showCartEntry =
    cartEntry.type === MinimalCartEntryType.combo ||
    cartEntry.type === MinimalCartEntryType.item ||
    cartEntry.type === MinimalCartEntryType.incentive ||
    cartEntry.type === MinimalCartEntryType.reward;

  if (!showCartEntry) {
    return null;
  }
  return (
    <View style={[styles.container, readOnly && styles.readOnly]}>
      <CartEntryHeader cartEntry={cartEntry} readOnly={readOnly} />
      <CartEntryBody cartEntry={cartEntry} readOnly={readOnly} />
      {!readOnly && (
        <CartEntryFooter
          cartEntry={cartEntry}
          isLoading={isContinueLoading}
          quantityOnCart={quantityOnCart}
        />
      )}
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: 'column',
    backgroundColor: primitive.$white,
    borderRadius: 10,
    overflow: 'hidden',
  },
  header: {
    borderTopLeftRadius: 10,
    borderTopRightRadius: 10,
    flexDirection: 'row',
    gap: 10,
    alignItems: 'center',
    paddingHorizontal: 16,
    paddingVertical: 14,
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
  footer: {
    flexDirection: 'row',
    paddingHorizontal: 16,
    paddingVertical: 8,
    borderTopWidth: 1,
    borderTopColor: primitive.$blackOpacity10,
    alignItems: 'center',
    gap: 16,
  },
  item: {
    flexDirection: 'row',
    gap: 12,
    alignItems: 'center',
    flex: 1,
    paddingHorizontal: 16,
    paddingVertical: 10,
    borderBottomWidth: 1,
    borderBottomColor: primitive.$blackOpacity10,
  },
  editText: {
    fontSize: 14,
    fontWeight: 'bold',
    fontFamily: primitive.fontFamily.$headers,
    color: primitive.$bbqBrown,
  },
  readOnly: {
    borderWidth: 1,
    borderColor: primitive.$blackOpacity10,
  },
});
